'use es6';

import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.genericInboxForm';
const InboxFormActions = ({
  onSubmit,
  onCancel,
  submitText,
  cancelText,
  isSubmittable
}) => /*#__PURE__*/_jsxs(Flex, {
  marginBlockStart: "500",
  justifyContent: "center",
  children: [/*#__PURE__*/_jsx(Button, {
    disabled: !isSubmittable,
    onClick: onSubmit,
    type: "submit",
    use: "primary",
    children: submitText || /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `${LANG_ROUTE}.submit`
    })
  }), onCancel && cancelText && /*#__PURE__*/_jsx(Button, {
    use: "link",
    onClick: onCancel,
    children: cancelText
  })]
});
InboxFormActions.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  submitText: PropTypes.node,
  cancelText: PropTypes.string,
  isSubmittable: PropTypes.bool
};
export default InboxFormActions;